import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=6ce5042f&"
import script from "./Team.vue?vue&type=script&async=true&defer=true&lang=js&"
export * from "./Team.vue?vue&type=script&async=true&defer=true&lang=js&"
import style0 from "./Team.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports